import React, { useMemo, useEffect, useCallback } from 'react';
import { Field, useFormikContext } from 'formik';

import { getDynVal } from '../../utils/DynHelper';
import { FormLabelUI, InputUI } from '../Interface';

const DynTextInput = (props) => {
  const { name, disabled, selectedValues, fieldData, showLabel } = props;
  const { property } = fieldData;
  const { setFieldValue } = useFormikContext();
  const dynVal = useMemo(
    () => getDynVal(selectedValues.dynamicProperties, name),
    [selectedValues.dynamicProperties, name]
  );

  useEffect(() => {
    const setterVal = dynVal?.textVal || dynVal?.numberVal || dynVal?.longTextVal || '';

    setFieldValue(name, setterVal);
  }, [dynVal, name, setFieldValue]);

  const handleChange = useCallback(
    (e) => {
      setFieldValue(name, e.target.value);
    },
    [name, setFieldValue]
  );
  return (
    <Field
      name={name}
      as={InputUI}
      fullWidth
      variant="standard"
      disabled={disabled}
      onChange={handleChange}
      label={showLabel ? <FormLabelUI text={property?.name} /> : undefined}
      {...props}
    />
  );
};

export default DynTextInput;
